<template>
  <div>
    <el-dialog :visible.sync="visible" width="400px" :center="false">
      <div slot="title" class="title-container"><span>Assign / Change a driver</span></div>
      <el-form label-width="120px">
        <el-form-item label="Driver">
          <el-select
            v-model="tDriverId"
            size="mini"
          >
            <el-option
              v-for="item in items"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled || false"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible">Cancel</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderDriverModify } from '../api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogDriver',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    },
    ...mapState('edit', ['id', 'driverId']),
    ...mapState({
      items: state => state.staff.filter(s => s.role === 6)
    })
  },
  data () {
    return {
      tDriverId: 0
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      reload: 'edit/loadOrder'
    }),
    async handleSubmit () {
      await orderDriverModify(this.id, this.tDriverId)

      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      this.reload(this.id)
      this.$emit('closed')
    },
    dialogFormVisible () {
      this.tDriverId = this.driverId
      this.$emit('closed')
    }
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.tDriverId = this.driverId
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
